import { networkSchemaRootPaths } from './networkSchemaRootPath';
import { trimBasenameAndNetworkFromUrlPath } from './trimBasenameFromUrlPath';
import { trimLeadingAndTrailingSlash } from './trimSlash';

export const urlRootPaths = [
  'achievements',
  'agent-suggestions',
  'articles',
  'authredirect',
  'configure',
  'curated-thread-list',
  'discover-groups',
  'events',
  'feed',
  'groups',
  'group-optimizations',
  'campaigns',
  'logout',
  'inbox',
  'campaigns-dashboard',
  'campaigns-hub',
  'personalized-inbox',
  'precache',
  'questions',
  'search',
  'storylines',
  'take-action',
  'teams-meeting',
  'threads',
  'topics',
  'topics-network-question',
  'network-themes',
  'usage-policy',
  'users',
  'user-settings',
  'org',
  'network',
  'admin',
  'leader-dashboard',
  'leadership-corner',
  'leaders',
  'ama',
  'broadcasts',
  'insights',
  'media-post',
  'dashboard',
  'officeusers',
  'communications-plans',
] as const;
export type UrlRootPath = (typeof urlRootPaths)[number];

const getSpecialRootPath = (urlPath: string): UrlRootPath | undefined => {
  if (urlPath.includes('/agent/suggestions')) {
    return 'agent-suggestions';
  }

  return undefined;
};

const getRootPath = (urlPath: string) => {
  const urlPathWithoutBasename = trimBasenameAndNetworkFromUrlPath(urlPath);
  const urlPathParts = trimLeadingAndTrailingSlash(urlPathWithoutBasename).split('/');

  return urlPathParts[0];
};

export type GetUrlRootPath = (urlPath: string) => string;
export const getUrlRootPath: GetUrlRootPath = (urlPath) => {
  const specialRootPath = getSpecialRootPath(urlPath);
  if (specialRootPath) {
    return specialRootPath;
  }

  const rootPath = getRootPath(urlPath);

  const hasEmptyPath = rootPath === '';

  const hasNetworkSchemaRootPath = networkSchemaRootPaths.includes(rootPath);
  const hasKnownRootPath = urlRootPaths.includes(rootPath as UrlRootPath);

  if (hasKnownRootPath && !hasNetworkSchemaRootPath) {
    return rootPath;
  }

  if (hasEmptyPath || hasNetworkSchemaRootPath) {
    return '';
  }

  return 'other';
};
